import React, {Component} from 'react';
import {LazyLoadImage} from "react-lazy-load-image-component";

class CardImagesAnimalDetail extends Component {

    constructor(props) {
        super(props);
        this.state = {
            imagesToLoad: 0,
            countImagesLoad: 0,
            mode: "fotos"
        };
        this.handleImagesLoad = this.handleImagesLoad.bind(this);
    }

    handleImagesLoad() {
        this.setState({countImagesLoad: this.state.countImagesLoad + 1});
    }

    renderIndicatorsImages() {
        if (this.props.animalDetail.galeria_imagenes.length === 0) {
            return (
                <div>
                </div>
            );
        } else {
            return this.props.animalDetail.galeria_imagenes.map((srcImage, index) => {
                let classIndicator = "";
                if (index === 0) {
                    classIndicator += " active";
                }
                let slideNumber = index.toString();
                return (
                    <li key={index} data-target="#carouselAnimal" data-slide-to={slideNumber}
                        className={classIndicator}/>
                );
            })
        }
    }

    renderIndicatorsVideos() {
        if (this.props.animalDetail.galeria_videos.length === 0) {
            return (
                <div>
                </div>
            );
        } else {
            return this.props.animalDetail.galeria_videos.map((srcVideo, index) => {
                let classIndicator = "";
                if (index === 0) {
                    classIndicator += " active";
                }
                let slideNumber = index.toString();
                return (
                    <li key={index} data-target="#carouselAnimal" data-slide-to={slideNumber}
                        className={classIndicator}/>
                );
            })
        }
    }

    renderImages() {
        if (this.props.animalDetail.galeria_imagenes.length === 0) {
            return (
                <div>
                    <h3>Sin fotos</h3>
                </div>
            );
        } else {
            return this.props.animalDetail.galeria_imagenes.map((srcImage, index) => {
                let classImage = "carousel-item";
                if (index === 0) {
                    classImage += " active";
                }
                return (
                    <div className={classImage} key={index} data-interval="2000">
                        <div
                            data-index={index}
                            className="listing-houses_icon-no-pic"
                            style={!this.state.mounted ? {} : {display: 'none'}}>
                            <span className="las la-4x la-image"/>
                        </div>
                        <LazyLoadImage
                            // className="d-block img-fluid"
                            className="d-block"
                            src={srcImage.url}
                            key={index} alt=""
                            width="400"
                            height="300"
                            threshold={150}

                            onLoad={this.handleImagesLoad}
                        />
                    </div>
                );
            })
        }
    }

    renderVideos() {
        if (this.props.animalDetail.galeria_videos.length === 0) {
            return (
                <div>
                    <h3>Sin Videos</h3>
                </div>
            );
        } else {
            return this.props.animalDetail.galeria_videos.map((srcVideo, index) => {
                let classVideo = "carousel-item";
                if (index === 0) {
                    classVideo += " active";
                }
                return (
                    <div className={classVideo} key={index}>
                        <Player
                            playsInline={true}
                            fluid={true}
                        >
                            <BigPlayButton position="center"/>
                            <source src={srcVideo}/>
                        </Player>
                    </div>
                );
            })
        }
    }

    capitalizeString(tkn) {
        if (tkn != undefined) {
            const REG_EXP_SEPARADORES = new RegExp(/[-.–\-,\/():“”"’'’#!?¿¡"@`^&]/, "gi")

            tkn = tkn.toLowerCase()
            let primeraLetra
            if (REG_EXP_SEPARADORES.test(tkn.slice(0, 1))) {
                primeraLetra = tkn.slice(0, 1) + tkn.slice(1, 2).toUpperCase()
                tkn = primeraLetra + tkn.slice(2, tkn.length)
            } else {
                primeraLetra = tkn.slice(0, 1).toUpperCase()
                tkn = primeraLetra + tkn.slice(1, tkn.length)
            }
        }

        return tkn;
    }

    render() {
        // let especie = this.props.especie;
        let showInfo;
        let nombre
        let classfoto = "btn btn-outline-primary";
        let classvideo = "btn btn-outline-primary";
        let classPrev = "carousel-control-prev";
        let classNext = "carousel-control-next";
        ((Object.keys(this.props.animalDetail).length === 0) ? showInfo = false : showInfo = true);

        if (showInfo) {
            nombre = this.capitalizeString(this.props.animalDetail.nombre)
        }

        if (this.state.mode === "fotos" && Object.keys(this.props.animalDetail.galeria_imagenes).length !== 0) {
            classfoto += " active";
            if (this.props.animalDetail && this.props.animalDetail.galeria_imagenes && this.props.animalDetail.galeria_imagenes.length === 0) {
                classPrev += " carousel-control-hidden";
                classNext += " carousel-control-hidden";
            }
        } else if (this.state.mode === "videos") {
            classvideo += " active";
            classPrev += " carousel-control-prev-video";
            classNext += " carousel-control-next-video";
            if (this.props.animalDetail.galeria_videos.length === 0) {
                classPrev += " carousel-control-hidden";
                classNext += " carousel-control-hidden";
            }
        } else {
            showInfo = false;
        }
    
        return (
            <div>
                {!showInfo &&
                <div>
                    No hay más fotos de {nombre}
                </div>
                }
                {showInfo &&
                <div className="cardInfoDetailShow">
                    <h3>{"Fotos de " + nombre}</h3>

                    <div className="informationDetailDescription_withImages">
                        {/*<div id="loaderImageIni">*/}
                        {/*    <div className="loaderImageText">C A R G A N D O . . .</div>*/}
                        {/*</div>*/}
                        <div className="contentImageVideo">
                            <div id="carouselAnimal" className="carousel slide" data-ride="carousel">
                                <ol className="carousel-indicators">
                                    {(this.state.mode === "fotos") ? this.renderIndicatorsImages() : this.renderIndicatorsVideos()}
                                </ol>
                                <div className="carousel-inner" role="listbox">
                                    {/*<div*/}
                                    {/*    id={"carousel-no-pic"}*/}
                                    {/*    className="listing-houses_icon-no-pic"*/}
                                    {/*    style={this.state.mounted ? {} : {display: 'none'}}>*/}
                                    {/*    <span className="las la-4x la-image"></span>*/}
                                    {/*</div>*/}
                                    {(this.state.mode === "fotos") ? this.renderImages() : this.renderVideos()}
                                </div>
                                <a className={classPrev} href="#carouselAnimal" role="button" data-slide="prev">
                                    <span className="carousel-control-prev-icon las la-3x la-angle-left"
                                          aria-hidden="true"/>
                                    <span className="sr-only">Previous</span>
                                </a>
                                <a className={classNext} href="#carouselAnimal" role="button" data-slide="next">
                                    <span className="carousel-control-next-icon las la-3x la-angle-right"
                                          aria-hidden="true"/>
                                    <span className="sr-only">Next</span>
                                </a>
                            </div>
                        </div>

                    </div>
                </div>
                }

            </div>
        );
    }

    componentWillMount() {
        // }
    }


    componentDidMount() {
        $(".switch-imagen-video").css("visibility", "hidden");
        $("#borde-superior-in").hide();


        this.setState({
            imagesToLoad: this.props.animalDetail.galeria_imagenes.length,
            mounted: true
        });


    }

    componentDidUpdate(prevProps, prevState, prevContext) {

    }




}
export default CardImagesAnimalDetail
